import { Button, Stack, type StackProps, Typography } from '@mui/material'
import { FC } from 'react'
import CloseIcon from '../../../assets/images/icons/close.svg?react'

export type FilterChipProps = { label: string; value: string; onDelete?: () => void } & StackProps

export const FilterChip: FC<FilterChipProps> = ({ label, value, onDelete, ...stackPropsOverrides }) => {
  return (
    <Stack
      direction={'row'}
      spacing={'var(--spacing-xs)'}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: 'var(--shape-medium)',
        borderRadius: 'var(--border-radius-round)',
        paddingX: 'var(--spacing-s)',
        paddingY: 'var(--spacing-xs)'
      }}
      {...stackPropsOverrides}
    >
      <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
      <Typography>|</Typography>
      <Typography>{value}</Typography>
      <Button variant={'text'} onClick={onDelete} sx={{ minWidth: 0, padding: 0 }}>
        <CloseIcon />
      </Button>
    </Stack>
  )
}
